/* eslint-disable no-restricted-imports */
import originalDayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Locale } from '@core/constants/locales.constants';
import advancedFormat from 'dayjs/plugin/advancedFormat';
// Load all locales
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';

// Load all dayjs extensions https://day.js.org/docs/en/plugin/plugin
originalDayjs.extend(relativeTime);
originalDayjs.extend(utc);
originalDayjs.extend(timezone);
originalDayjs.extend(localizedFormat);
originalDayjs.extend(updateLocale);
originalDayjs.extend(advancedFormat);

/**
 * This function adjusts the locale of the dayjs object. It uses the provided locale and sets it
 * for usage in the dayjs date library. The locale is set according to the customization options
 * provided by dayjs.
 *
 * @param {Locale} locale - The locale to be set in dayjs. It should be an object value from the available locales.
 * @returns {originalDayjs} A dayjs instance with the specified locale.
 *
 * @example
 * // Assume LOCALES is an object that looks like this: { EN: 'en', JP: 'jp' }
 * const newDayJs = dayjs(LOCALES.EN);
 * // newDayJs is a dayjs instance configured to use English locale.
 */
export default function dayjs(locale: Locale) {
  // https://day.js.org/docs/en/display/format#docsNav
  // https://day.js.org/docs/en/customization/customization
  // originalDayjs.updateLocale(locale, {
  //   formats: {
  //     LT: 'HH:mm',
  //     LTS: 'HH:mm:ss',
  //     L: 'DD/MM/YYYY',
  //     LL: 'D MMMM YYYY',
  //     LLL: 'D MMMM YYYY HH:mm',
  //     LLLL: 'dddd D MMMM YYYY HH:mm',
  //   },
  // });
  originalDayjs.locale(locale);
  return originalDayjs;
}
/* eslint-enable no-restricted-imports */
